import { Box } from "@mui/material"
import { styled } from "@mui/system"
import { VideoPlatform, VideoPlatformDetail } from "app-constants/constants"
import { pxToRem } from "utils/helpers"

interface VideoPlatformProps {
  platform: VideoPlatform
  className?: string
}

const VideoPlatformText = (props: VideoPlatformProps) => {
  const { platform, className } = props
  const videoPlatformDetail = VideoPlatformDetail[platform]

  return (
    <_Container className={className}>
      <videoPlatformDetail.Icon />
      <p>{videoPlatformDetail.name}</p>
    </_Container>
  )
}

export default VideoPlatformText

const _Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexFlow: "nowrap row",
  alignItems: "center",
  gap: pxToRem(10),
  ...theme.fonts.lato400,
})) as typeof Box
